import { BE_BASE_URL } from 'common/constants'
import { objectToQueryParams } from 'common/helpers/request-helper'

export const exportUnderOverDepreciationURL = (payload: any) => {
  const params = objectToQueryParams(payload)
  return `${BE_BASE_URL}/v1/export/under_over_depreciation?${params}`
}
